import { ReferralStatus } from './Referrals.utils';

// Metric Type Enum
export enum MetricType {
  EXPIRING_SOON = 'expiring_soon',
  CLOSER_TO_PAYOUT = 'closer_to_payout',
  NEEDS_NUDGE = 'needs_nudge',
}

// Action types
export const SET_REFERRAL_SUMMARY = 'SET_REFERRAL_SUMMARY';
export const SET_REFERRAL_DATA = 'SET_REFERRAL_DATA';
export const APPEND_REFERRAL_DATA = 'APPEND_REFERRAL_DATA';
export const SET_BANNER_DATA = 'SET_BANNER_DATA';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_SORT = 'SET_SORT';
export const SET_PAGINATION = 'SET_PAGINATION';
export const RESET_PAGINATION = 'RESET_PAGINATION';
export const SET_LAST_FETCHED_STATE = 'SET_LAST_FETCHED_STATE';
export const CLEAR_REFERRAL_DATA = 'CLEAR_REFERRAL_DATA';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_MORE = 'SET_LOADING_MORE';
export const SET_BANNER_LOADING = 'SET_BANNER_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_SELECTED_REFERRAL = 'SET_SELECTED_REFERRAL';
export const SET_HAS_FETCHED_SUMMARY_METRICS = 'SET_HAS_FETCHED_SUMMARY_METRICS';

// Types
export interface ReferralFilter {
  dateRange: string;
  startDate?: Date | null;
  endDate?: Date | null;
  status: ReferralStatus | string[] | string;
  searchQuery: string;
  metric_type_list?: string[];
}

export interface ReferralSort {
  field: string;
  order: 'asc' | 'desc';
}

export interface ReferralPagination {
  lastFetchedId: string | null;
  resultPerPage: number;
  nextOrPrev: 'first' | 'next' | 'prev';
  lastSortedColumnValue: string | null;
  isNextPresent: boolean;
  lastRowIdPrev: string | null;
  lastSortedColumnValuePrev: string | null;
  lastSortedColumnValueNext: string | null;
}

export interface ReferralSummary {
  data: {
    total_earnings: number;
    maximum_possible_earning: number;
    is_first_time_referrer?: boolean;
    program_start_date?: string;
    program_end_date?: string;
    stats: {
      referred: number;
      onboarded: number;
      expired: number;
    };
    referral_summary?: {
      expiring_soon?: number | null;
      closer_to_payout?: number | null;
      needs_nudge?: number | null;
    };
  };
}

export interface ReferralsState {
  referralSummary: ReferralSummary | null;
  referralData: any;
  bannerData: any | null;
  selectedReferral: any | null;
  filters: ReferralFilter;
  sort: ReferralSort;
  pagination: ReferralPagination;
  lastFetchedFilters: ReferralFilter | null;
  lastFetchedSort: ReferralSort | null;
  loading: boolean;
  loadingMore: boolean;
  bannerLoading: boolean;
  error: string | null;
  hasFetchedSummaryMetrics: boolean;
}

export interface ReferralStats {
  total_earnings: number;
  maximum_possible_earning: number;
  is_first_time_referrer?: boolean;
  program_start_date?: string;
  program_end_date?: string;
  referred: number;
  onboarded: number;
  expired: number;
  referral_summary?: {
    expiring_soon?: number | null;
    closer_to_payout?: number | null;
    needs_nudge?: number | null;
  };
}

// Action interfaces
export interface SetReferralSummaryAction {
  type: typeof SET_REFERRAL_SUMMARY;
  payload: ReferralSummary;
}

export interface SetReferralDataAction {
  type: typeof SET_REFERRAL_DATA;
  payload: any;
}

export interface AppendReferralDataAction {
  type: typeof APPEND_REFERRAL_DATA;
  payload: any;
}

export interface SetBannerDataAction {
  type: typeof SET_BANNER_DATA;
  payload: any;
}

export interface SetBannerLoadingAction {
  type: typeof SET_BANNER_LOADING;
  payload: boolean;
}

export interface SetSelectedReferralAction {
  type: typeof SET_SELECTED_REFERRAL;
  payload: any;
}
export interface SetFiltersAction {
  type: typeof SET_FILTERS;
  payload: Partial<ReferralFilter>;
}

export interface SetSortAction {
  type: typeof SET_SORT;
  payload: ReferralSort;
}

export interface SetPaginationAction {
  type: typeof SET_PAGINATION;
  payload: ReferralPagination;
}

export interface ResetPaginationAction {
  type: typeof RESET_PAGINATION;
}

export interface SetLoadingAction {
  type: typeof SET_LOADING;
  payload: boolean;
}

export interface SetLoadingMoreAction {
  type: typeof SET_LOADING_MORE;
  payload: boolean;
}

export interface SetErrorAction {
  type: typeof SET_ERROR;
  payload: string;
}

export interface ClearErrorAction {
  type: typeof CLEAR_ERROR;
}

export interface SetLastFetchedStateAction {
  type: typeof SET_LAST_FETCHED_STATE;
  payload: {
    filters: ReferralFilter;
    sort: ReferralSort;
  };
}

export interface ClearReferralDataAction {
  type: typeof CLEAR_REFERRAL_DATA;
}

export interface SetHasFetchedSummaryMetricsAction {
  type: typeof SET_HAS_FETCHED_SUMMARY_METRICS;
  payload: boolean;
}

export type ReferralActions =
  | SetReferralSummaryAction
  | SetReferralDataAction
  | AppendReferralDataAction
  | SetBannerDataAction
  | SetBannerLoadingAction
  | SetSelectedReferralAction
  | SetFiltersAction
  | SetSortAction
  | SetPaginationAction
  | ResetPaginationAction
  | SetLastFetchedStateAction
  | ClearReferralDataAction
  | SetLoadingAction
  | SetLoadingMoreAction
  | SetErrorAction
  | ClearErrorAction
  | SetHasFetchedSummaryMetricsAction;
